import React from "react";

export default function Logo({ height = 36, showAtlas = true, label = "Atlas" }) {
  return (
    <span style={{ display: "inline-flex", alignItems: "center", gap: 8 }} data-testid="afrifute-logo">
      <img
        src="/afrifute-logo-nav.png"
        alt="AfriFuté"
        width={Math.round((height * 312) / 120)}
        height={height}
        decoding="async"
        style={{ height, width: "auto", display: "block" }}
      />
      {showAtlas && (
        <>
          <span style={{
            display: "inline-block",
            width: 1,
            height: Math.round(height * 0.5),
            background: "rgba(255,255,255,0.35)",
            flexShrink: 0,
          }} />
          <span style={{
            fontFamily: "'Space Grotesk',sans-serif",
            fontWeight: 600,
            fontSize: Math.round(height * 0.5),
            color: "var(--gold)",
            letterSpacing: "-0.3px",
            lineHeight: 1,
          }}>
            {label}
          </span>
        </>
      )}
    </span>
  );
}
